module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--messaging main--full-height"
  }, [_c('div', {
    staticClass: "appointments messaging group group--first-last group--wide messaging--sidebar"
  }, [_c('img', {
    staticClass: "appointments__image",
    attrs: {
      "src": _vm.illustration
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "appointments__content"
  }, [_c('h1', {
    staticClass: "c-accent appointments__title",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("My Appointments")]), _vm._v(" "), (_vm.userAppointments.length <= 0) ? _c('div', [_c('p', {
    staticClass: "mt2 p xlarge fw-regular"
  }, [_vm._v("\n          You don't have any upcoming phone or video sessions.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "pt2 p fw-regular"
  }, [_vm._v("\n          Looking for next steps?\n          "), _c('router-link', {
    attrs: {
      "to": "/appointment-type"
    }
  }, [_vm._v("Get started")]), _vm._v(" with a\n          request for emotional support"), _c('br'), _vm._v("\n          or give us a call at " + _vm._s(_vm.setPhone(_vm.org.phone)) + ".\n        ")], 1)]) : _vm._e(), _vm._v(" "), (_vm.userAppointments.length > 0) ? _c('div', {
    staticClass: "appointments__header"
  }, [_c('h3', [_vm._v("Counselor")]), _vm._v(" "), _c('h3', [_vm._v("Details")]), _vm._v(" "), _c('h3', [_vm._v("Status")])]) : _vm._e(), _vm._v(" "), (_vm.userAppointments.length > 0) ? _c('div', {
    staticClass: "appointments__table"
  }, _vm._l((_vm.userAppointments), function(appointment) {
    return _c('div', {
      key: appointment.id,
      staticClass: "table"
    }, [(_vm.cancelling === 'confirm') ? [_c('div', {
      key: "confirm",
      staticClass: "cover cover--fixed bg-primary ovh df aic jcc appointments__overlay"
    }, [_c('div', [_c('h1', {
      staticClass: "c-accent",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      })
    }, [_vm._v("Are you sure you want to cancel?")]), _vm._v(" "), _c('p', {
      staticClass: "p"
    }, [_vm._v("\n                  You might not be able to get another appointment at the same\n                  time or with the same counselor.\n                ")]), _vm._v(" "), _c('module-button', {
      attrs: {
        "button": "secondary"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.cancelAppointment(_vm.appointmentId)
        }
      }
    }, [_vm._v("\n                  Yes, Cancel\n                ")]), _vm._v(" "), _c('module-button', {
      attrs: {
        "button": "secondary"
      },
      nativeOn: {
        "click": function($event) {
          return (function () {
            _vm.cancelling = false;
          }).apply(null, arguments)
        }
      }
    }, [_vm._v("\n                  No, never mind\n                ")])], 1)])] : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "table__column"
    }, [_c('h3', {
      staticClass: "c-accent h2 mt0 mb0",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      })
    }, [_vm._v("\n              " + _vm._s(appointment.provider.full_name) + "\n            ")]), _vm._v(" "), _c('p', {
      staticClass: "p pt0 mt0 fw-bold mb0"
    }, [_vm._v("\n              " + _vm._s(appointment.provider.provider_type) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "table__column mr2"
    }, [_c('p', {
      class: [
        "p mt0 mb0 df aic",
        {
          'c-accent': _vm.isAfter(appointment.start_date)
        }
      ],
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      })
    }, [(
      appointment.appointment_by === 'video' &&
      _vm.isAfter(appointment.start_date)
    ) ? _c('img', {
      staticClass: "mr-tiny",
      attrs: {
        "src": _vm.images['videoAccent'].src,
        "alt": _vm.images['videoAccent'].alt,
        "width": "16px"
      }
    }) : _vm._e(), _vm._v(" "), (
      appointment.appointment_by === 'phone' &&
      _vm.isAfter(appointment.start_date)
    ) ? _c('img', {
      staticClass: "mr-tiny",
      attrs: {
        "src": _vm.images['phoneAccent'].src,
        "alt": _vm.images['phoneAccent'].alt,
        "width": "16px"
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.isAfter(appointment.start_date)) ? _c('img', {
      staticClass: "mr-tiny",
      attrs: {
        "src": _vm.images[appointment.appointment_by].src,
        "alt": _vm.images[appointment.appointment_by].alt,
        "width": "16px"
      }
    }) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.formatDate(appointment.start_date)) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "table__column"
    }, [(
      _vm.isSoon(appointment.start_date) &&
      appointment.appointment_by === 'video' && !appointment.completed
    ) ? _c('module-button', {
      attrs: {
        "size": "s",
        "button": "primary"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.openAppointment(appointment.id)
        }
      }
    }, [_vm._v("\n              Join Video Chat\n            ")]) : _vm._e(), _vm._v(" "), (
      _vm.isAfter(appointment.start_date) &&
      !_vm.isSoon(appointment.start_date)
    ) ? _c('module-button', {
      attrs: {
        "size": "s"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.rescheduleAppointment(appointment)
        }
      }
    }, [_vm._v("\n              Reschedule\n            ")]) : _vm._e(), _vm._v(" "), (
      _vm.isAfter(appointment.start_date) &&
      !_vm.isSoon(appointment.start_date)
    ) ? _c('module-button', {
      attrs: {
        "size": "s"
      },
      nativeOn: {
        "click": function($event) {
          return (function () {
            _vm.cancelling = 'confirm';
            _vm.appointmentId = appointment.id;
          }).apply(null, arguments)
        }
      }
    }, [_vm._v("\n              Cancel\n            ")]) : _vm._e(), _vm._v(" "), (appointment.completed) ? _c('p', [_vm._v("Completed")]) : _vm._e()], 1)], 2)
  }), 0) : _vm._e()])]), _vm._v(" "), (_vm.cancelling === 'loading') ? _c('ui-module-loader', {
    key: "loader",
    attrs: {
      "messages": [
        'Please give us a moment to cancel',
        'All set, your appointment has been cancelled'
      ]
    },
    on: {
      "messages-complete": _vm.onMessagesComplete
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2a76052"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/appointment/Appointments.vue
// module id = 464
// module chunks = 0